import i18next from "i18next";

import type { ParsedBackendError } from "../types/error.types";

const BACKEND_ERROR_REGEX = /^(\d+\.\d+\.(\d+))\s*=\s*(.+)$/;

export function parseBackendError(
  message: string,
): ParsedBackendError | null {
  const match = message.match(BACKEND_ERROR_REGEX);

  if (!match) return null;

  const [, code, errorCodeSuffix, originalMessage] = match;

  const i18nKey = `errors.error${errorCodeSuffix}`;
  const translatedMessage = i18next.exists(i18nKey)
    ? i18next.t(i18nKey)
    : i18next.t("errors.errorFallback");

  const formattedMessage = `${translatedMessage} - COD. ${code}`;

  return {
    translatedMessage,
    formattedMessage,
    code,
    errorCodeSuffix,
    originalMessage: originalMessage.trim(),
  };
}
